import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { BaseComponent } from '~Interfaces/basecomponent';
import { AuthentificationService } from '../../services/authentification.service';

/**
 * Composant pour r�initialiser le mot de passe
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-reinitialiser-mot-de-passe',
  templateUrl: './reinitialiser-mot-de-passe.component.html',
  styleUrls: ['./reinitialiser-mot-de-passe.component.scss']
})
export class ReinitialiserMotDePasseComponent extends BaseComponent implements OnInit {
    login: string = '';
    loading: boolean = false;
    subscription: Subscription;

    /**
     * Constructeur
     * @param authentificationService
     * @param route
     * @param router
     */
    constructor(
        @Inject(AuthentificationService) private authentificationService: AuthentificationService,
        private route: ActivatedRoute,
        private router: Router)
    {
        super();
    }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
        // R�cup�ration du login
        this.login = this.route.snapshot.queryParams['login'];
        if (this.login) {
            this.router.navigate([], {
                queryParams: {
                    'login': null
                },
                queryParamsHandling: 'merge'
            });
        }
    }

    /**
     * Envoyer le forumlaire pour r�initialiser le mot de passe
     */
    envoyer() {
        this.loading = true;
        this.authentificationService.reinitialiserMotDePasse(this.login).subscribe((retour: any) => {
            this.loading = false;
            if (retour && retour.Result) {
                this.router.navigate(['/login']);
            }
        }, (erreur) => {
            this.loading = false;
            console.error(erreur);
        });
    }
}
